<template>
    <div class="sa-tab-scroll sa-form-container">
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <b-card class="sa-card" header="Dettagli" header-tag="header" footer-tag="footer" title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Nome</label>
                            <span>{{ jsonDataTipoPrestazione.nome }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Codice Prestazione</label>
                            <span>{{ jsonDataTipoPrestazione.codicePrestazione }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Regime</label>
                            <span>{{ jsonDataTipoPrestazione.regime }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Importo</label>
                            <span>{{ jsonDataTipoPrestazione.importo + "€" }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Quota ASL(%)</label>
                            <span>{{ jsonDataTipoPrestazione.percentualeAsl + "%" }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Quota ASL(€)</label>
                            <span>{{ jsonDataTipoPrestazione.quotaAsl + "€" }} </span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <label class="sa-label-data">Note</label>
                            <span>{{ jsonDataTipoPrestazione.note }}</span>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    data() {
        return {
            pathResource: "/rsatipoprestazioni",
            id: null,
            linkedit: "",
            showModalLoading: false,
            jsonDataTipoPrestazione: {},
        };
    },

    watch: {
        jsonDataTipoPrestazione: {
            handler(jsonDataTipoPrestazione) {
                this.$emit("update", jsonDataTipoPrestazione);
            },
            deep: true,
        },
    },

    mounted() {
        let me = this;
        me.id = this.$route.params.id;
        me.loadData();
    },

    methods: {
        loadData() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResource + "/" + me.id, null, me.loadSuccessData, me.loadErrorData);
        },
        loadSuccessData(response) {
            let me = this;
            me.jsonDataTipoPrestazione = response.data.data;
        },
        loadErrorData(response) {
            let me = this;
            console.log(response);

            me.$bvToast.toast("Errore nel carimento dati:", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
    },
};
</script>

<style scoped>
.sa-form-container {
    padding: 1rem;
    background-color: #f8f9fa;
    min-height: 100%;
}
</style>
